export const getImportInfo = () => {
    return {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + getToken() },
    }
}

const getToken = () => document.cookie.replace(/(?:(?:^|.*;\s*)AUTH_TOKEN\s*\=\s*([^;]*).*$)|^.*$/, "$1");